import React from 'react';

// Generic file icon (paper with folded corner) matching stroke style
export default function FileIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 6h18l10 10v22c0 2.2-1.8 4-4 4H14c-2.2 0-4-1.8-4-4V6Z" fill="currentColor" fillOpacity="0.06" />
      <path d="M28 6v10h10" />
      <path d="M16 24h16" />
      <path d="M16 32h10" />
    </svg>
  );
}